import { IconButton, Button } from '@mui/material'
import React, { useState } from 'react'
import BasicModal from '../../../components/shared/modals/BaseModal'
import { Edit } from '@mui/icons-material'
// import { useKeycloak } from '@react-keycloak/web'
import { object, func } from 'prop-types'
import CadObra from './CadObra'

const OpenButton = ({ ...props }) => (
  <IconButton {...props} sx={{ color: 'rgba(234, 144, 39, 1)' }}>
    <Edit />
  </IconButton>
)

const editFilter = ({
  id,
  titulo,
  categoria_obra_id,
  palavra_chave,
  data_publicacao,
  numero_edicao,
  numero_pagina,
  editora_id,
  isbn,
  obra_autores
}) => {
  const autores = generateObraAutores(obra_autores)
  const aux = {
    id,
    titulo,
    categoria_obra_id,
    palavra_chave,
    data_publicacao,
    numero_edicao,
    numero_pagina,
    editora_id,
    isbn,
    autores
  }
  return aux
}
const generateObraAutores = (autores = []) => {
  let result = ''
  autores.forEach((element, index) => {
    result +=
      index + 1 < autores?.length
        ? element.autor.nome + ', '
        : element.autor.nome
  })
  return result
}

const EditLivroModal = ({ data, getBooks }) => {
  const [status, setStatus] = useState(false)
  const [form, setForm] = useState(editFilter({ ...data }))
  const submitEnd = () => {
    getBooks()

    setStatus(false)
  }

  const FormBackButton = () => {
    return (
      <Button
        onClick={() => {
          setStatus(false)
        }}
        variant="outlined"
        color="error"
      >
        Voltar
      </Button>
    )
  }

  return (
    <BasicModal
      status={status}
      Caller={OpenButton}
      closeEvent={event => {
        setStatus(event)
      }}
      title="Editar Obra"
      sx={{ minWidth: '60vw', width: { xs: '100vw', md: '60vw' } }}
    >
      <>
        <CadObra
          form={form}
          onFormChange={e => setForm(e)}
          BackButton={FormBackButton}
          submitEnd={submitEnd}
          submitMethod="put"
        />
      </>
    </BasicModal>
  )
}
EditLivroModal.propTypes = {
  form: object,
  data: object,
  getBooks: func
}
export default EditLivroModal
